import { makeRequest } from './auth/baseCredencial'

export const apiLocais = async () => {
    return makeRequest(
        "/api/agendamento/locais/get",
        {}
    );
}

